// extracted by mini-css-extract-plugin
export const container = "Introduction-module--container--i0al_";
export const intro = "Introduction-module--intro--1N-Pj";
export const introHeader = "Introduction-module--introHeader--1n0UC";
export const introDescription = "Introduction-module--introDescription--328P5";
export const introAction = "Introduction-module--introAction--3wK5X";
export const introButton = "Introduction-module--introButton--3vLeH";
export const introNote = "Introduction-module--introNote--14R8Q";
export const introMedia = "Introduction-module--introMedia--1qwoE";